import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import WmsModel from "./../../components/WmsModel/WmsModel";
import WmsDropdown from "./../../components/WmsDropdown/WmsDropdown";
import WmsDropdownList from "./../../components/WmsDropdownList/WmsDropdownList";
import WmsInput from "./../../components/WmsInput/WmsInput";
import WmsButton from "./../../components/WmsButton/WmsButton";
import * as auditInventoryServices from "./../audit-inventory.services";
import * as GlobalService from "./../../global_services";

import "../audit-inventory.scss";

declare var window: any;

interface Props {
    isOpenManageAuditInventoryModal: boolean;
    onCloseManageBatchAuditInventoryModal: any;
    wmsSelector: string;
    windowId: string;
    selectedRowData: any;
    auditBatchType: string;
    userOptions: any;
    facId: any;
    batchList: any;
}
const defaultAuditJobObject = {
    Name: "",
    Priority: 8,
    AssignedTo: { Id: "" },
    InventoryAuditIds: [],
    batchEditUri: "",
};

const ManageBatchAuditInventoryModal: React.FC<Props> = (incomingProps: Props): any => {
    const {
        onCloseManageBatchAuditInventoryModal = (): void => {},
        isOpenManageAuditInventoryModal = false,
        wmsSelector = "",
        windowId = "",
        auditBatchType = "Create",
        userOptions = [],
        facId = 0,
    } = incomingProps;
    const props = {
        ...incomingProps,
        onCloseManageBatchAuditInventoryModal,
        isOpenManageAuditInventoryModal,
        wmsSelector,
        windowId,
        auditBatchType,
        userOptions,
        facId,
    };

    const [batchAuditJobObj, setBatchAuditJobObj] = useState(defaultAuditJobObject);
    const [isSaveBatchAuditJobLoading, setIsSaveBatchAuditJobLoading] = useState(false);

    const findMatchingBatch = (batchList, selectedRowData) => {
        if (!batchList?.length || !selectedRowData?.length) return null;
        const batchName = selectedRowData[0].BatchName;
        return batchList.find((batch) => batch.Name === batchName);
    };

    const [jobPriorityOption] = useState([
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
        { value: 6, text: 6 },
        { value: 7, text: 7 },
        { value: 8, text: 8 },
        { value: 9, text: 9 },
        { value: 10, text: 10 },
    ]);

    useEffect(() => {
        if (props.auditBatchType === "Edit") {
            const matchingBatch = findMatchingBatch(props.batchList, props.selectedRowData);
            const assignedTo = matchingBatch.AssignedUser ? { Id: matchingBatch.AssignedUser.Id } : { Id: "" };

            setBatchAuditJobObj({
                Name: matchingBatch.Name,
                Priority: matchingBatch.Priority,
                AssignedTo: assignedTo,
                InventoryAuditIds: matchingBatch.InventoryAuditIds,
                batchEditUri: matchingBatch._links[0].Href,
            });
        }
    }, [props.selectedRowData, props.auditBatchType, props.batchList]);

    const onChangeBatchFields = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "AssignedTo") {
            value = { Id: value.Id };
        }
        setBatchAuditJobObj((prevState: any) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleBatchNameError = () => {
        setIsSaveBatchAuditJobLoading(false);
    };

    const onSaveBatchAuditJob = () => {
        setIsSaveBatchAuditJobLoading(true);

        const InventoryAuditIds = batchAuditJobObj.InventoryAuditIds?.length
            ? batchAuditJobObj.InventoryAuditIds
            : props.selectedRowData.map((item: any) => parseInt(item.EditUri?.split("/").pop()));

        const saveAuditBatchData = {
            Name: batchAuditJobObj.Name,
            Priority: batchAuditJobObj.Priority,
            InventoryAuditIds: InventoryAuditIds,
        };
        if (props.auditBatchType === "Edit") {
            const editBatchData = {
                batch: { ...saveAuditBatchData, AssignedUser: batchAuditJobObj.AssignedTo },
                editUri: batchAuditJobObj.batchEditUri,
            };
            auditInventoryServices
                .editBatch(editBatchData)
                .then(() => {
                    GlobalService.notification("success", window.translate("Label_Batch_Updated_Successfully"));

                    setIsSaveBatchAuditJobLoading(false);
                    props.onCloseManageBatchAuditInventoryModal(true);
                })
                .catch((error) => {
                    console.log("error", error);
                    handleBatchNameError();
                });
        } else {
            auditInventoryServices
                .saveBatchAuditJob({
                    ...saveAuditBatchData,
                    AssignedUser: !batchAuditJobObj.AssignedTo.Id ? "" : batchAuditJobObj.AssignedTo,
                })
                .then(() => {
                    GlobalService.notification("success", window.translate("Label_Batch_Created_Successfully"));

                    props.onCloseManageBatchAuditInventoryModal(true);
                })
                .catch((error) => {
                    console.log("error", error);
                    handleBatchNameError();
                });
        }
    };
    return (
        <WmsModel
            id="ManageBatchAuditInventoryModal"
            title={
                props.auditBatchType === "Create"
                    ? window.translate("Create_Batch_Audit_Job")
                    : window.translate("Label_Edit_Batch")
            }
            width={665}
            height={800}
            onCloseFunc={props.onCloseManageBatchAuditInventoryModal}
            isOpen={props.isOpenManageAuditInventoryModal}
            customClass="wms-model-new-ui-wrapper"
            actions={[]}
            overlayHide={false}
            windowId={props.windowId}
            appendTo={"#" + props.windowId}
        >
            <div className={"model-content-wrapper"}>
                <WmsInput
                    id="Name"
                    inputName="Name"
                    wmsSelector={props.wmsSelector + "SearchJobName"}
                    onChangeFunc={onChangeBatchFields}
                    label={window.translate("Label_Batch_Name")}
                    required={props.auditBatchType === "Create"}
                    value={batchAuditJobObj.Name}
                    extraWrapperClass={"batch-name-input"}
                    readOnly={props.auditBatchType === "Edit"}
                />
                <WmsDropdownList
                    id={"AssignedTo"}
                    name="AssignedTo"
                    label={window.translate("Label_Assign_To")}
                    wmsSelector={props.wmsSelector + "AssignedTo"}
                    value={batchAuditJobObj.AssignedTo.Id}
                    onChangeFunc={onChangeBatchFields}
                    valueField="Id"
                    textField="Name"
                    isVirtualOptions={false}
                    staticOptions={props.userOptions}
                    extraWrapperClass="assigned-to-wrapper"
                />
                <WmsDropdown
                    id="Priority"
                    name="Priority"
                    label={window.translate("Label_Priority")}
                    wmsSelector={props.wmsSelector + "Priority"}
                    onChangeFunc={onChangeBatchFields}
                    options={jobPriorityOption}
                    value={batchAuditJobObj.Priority}
                    valueField="value"
                    textField="text"
                    extraWrapperClass="priority-wrapper form_group"
                />
            </div>
            <div className="footer-btn-holder">
                <WmsButton
                    label={window.translate("Label_Cancel")}
                    wmsSelector={props.wmsSelector + "DiscardExit"}
                    onClickFunc={props.onCloseManageBatchAuditInventoryModal}
                    buttonType="orange"
                    icon={"fa-ban"}
                />
                <WmsButton
                    label={window.translate("Label_Save")}
                    wmsSelector={props.wmsSelector + "Save"}
                    onClickFunc={onSaveBatchAuditJob}
                    disabled={!batchAuditJobObj.Name}
                    icon={"fa-floppy-o"}
                    loading={isSaveBatchAuditJobLoading}
                    parentClassName={"apply-adjustment-button"}
                />
            </div>
        </WmsModel>
    );
};
ManageBatchAuditInventoryModal.propTypes = {
    onCloseManageBatchAuditInventoryModal: PropTypes.any.isRequired,
    isOpenManageAuditInventoryModal: PropTypes.bool.isRequired,
    wmsSelector: PropTypes.string.isRequired,
    windowId: PropTypes.string.isRequired,
    auditBatchType: PropTypes.string,
    userOptions: PropTypes.any,
    facId: PropTypes.number,
};

export default React.memo(ManageBatchAuditInventoryModal);
